import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(), _createBlock(_component_a_tooltip, {
    title: $props.title,
    trigger: $props.trigger,
    placement: $props.placement,
    overlayClassName: $props.overlayClassName,
    open: $setup.isShow,
    onMouseenter: $setup.showToolTip,
    onMouseleave: $setup.closeToolTip
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["title", "trigger", "placement", "overlayClassName", "open"]))
}